import { Injectable, inject } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { filter, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { CommonDataService } from '../common-data.service';
import { UserService } from './user.service';

import { StaticContentService } from '../static-content.service';

export interface IBuyCryptoMethods {
  Logo: string;
  Comission: string;
  TimeProcessing: string;
  Verification: string;
  PaymentLogo: string;
  ModalTitle: string;
  ModalContent: any;
  PaymentMethod: string;
}

export const BUY_CRYPTO_TYPES = {
  mercuryo: 'mercuryo',
  moonpay: 'moonpay',
};

@Injectable({
  providedIn: 'root'
})
export class UserThirdPartyCryptoService {
  private _common = inject(CommonDataService);
  private _user = inject(UserService);
  private _static = inject(StaticContentService);


  private _multiProtocolMethod = null;

  private _isMultiProtocol: boolean = null;

  /**
   * Array of cryptocurrencies
   * @private
   */
  private _currencies: string[] = [];

  /**
   * Payment crypto methods
   * @private
   */
  private _methods: any[] = [];

  /**
   * Get widget id from CMS
   * @private
   */
  public widgetId$: Observable<any> = this._static.item({slug: 'widget-id'})
    .pipe(
      filter(list => !!list),
      map(list => list[0]?.Content));

  get buyCryptoTypes() {
    return BUY_CRYPTO_TYPES;
  }

  /**
   * Payment crypto methods getter
   * @private
   */
  public get methods(): any[] {
    return this._methods;
  }

  /**
   * Array of cryptocurrencies getter
   * @private
   */
  public get currencies(): string[] {
    return this._currencies;
  }

  public get multiProtocolMethod(): any {
    return this._multiProtocolMethod;
  }

  public get isMultiProtocol(): boolean {
    return this._isMultiProtocol;
  }

  /**
   * Fetch all crypto methods and addresses
   * @private
   */
  public fetchCryptoAddresses(currency: any[] = this._common.cryptoCurrencyList): Observable<any> {
    return from(currency).pipe(
      // mergeMap((e) => this._getMethodsByCurrency$(e)),
      tap(method => {
        if (Boolean(method?.config?.protocols?.length) && method?.config?.protocols?.length > 1) {
          this._isMultiProtocol = true;
          this._multiProtocolMethod = method;
        } else {
          this._isMultiProtocol = false;
          this._multiProtocolMethod = null;
        }
        if (method?.fields) {
          this._methods.push(...method.fields);
        }
      }),
    );
  }

  /**
   * Map crypto addresses
   * @param methods
   * @param lowerCaseCurrency
   * @private
   */
  public mapAddress(methods: any[], lowerCaseCurrency: boolean = false) {
    return methods.filter(e => e.field === 'address').map(item => {
      return {
        currency: lowerCaseCurrency ? item.currency.toLowerCase() : item.currency,
        address: item.placeholder
      };
    }).reduce((obj, item) =>
      ({...obj, [item.currency]: item.address}), {});
  }
}
